export const isAndroid = (): boolean => {
  return navigator.userAgent.toLowerCase().indexOf('android') > -1
}
